import React from 'react';
import CSSModules from 'react-css-modules';
import FacebookShare from 'src/components/FacebookShare/FacebookShare';
import styles from './RichUpdatesItemShare.scss';
import { sendEvent } from 'src/helpers/api/analytics';
import { generateHash } from 'src/helpers/hashId';

interface Props {
  updateId: number;
  message?: string;
  type: string;
}

const RichUpdatesItemShare: React.StatelessComponent<Props> = ({
  updateId,
  message,
  type,
}) => {
  const shareHash = generateHash();

  const onFacebookShare = () => {
    sendEvent({
      pageType: 'crowdfunding page',
      eventName: 'click',
      subtype: 'button',

      properties: {
        event_value: 'share to facebook',
        page_section: `update > ${type}`,
        social_type: 'feed',
        activity_type: 'crowdfunding_guid',
        social_utm_term: shareHash,
      },
    });
  };

  return (
    <div className={styles.container}>
      <p className={styles.text}>Share this update to help us raise more</p>
      <div className={styles['facebook-container']}>
        <FacebookShare
          customStyle="jg-btn jg-btn--facebook"
          isActive
          isUpdate
          location="updates"
          buttonText="Share"
          updateId={updateId}
          quote={message}
          shareOnFacebookOpened={onFacebookShare}
          shareHash={shareHash}
        />
      </div>
    </div>
  );
};

export default CSSModules(RichUpdatesItemShare, styles);



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/RichUpdatesItemShare.tsx